<template>
  <a-form ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
    <SmallSquare class="m-b-20" content="基础信息" />
    <a-form-item ref="name" label="提货券名称" name="name">
      <a-row>
        <a-col :span="9">
          <a-input v-model:value="form.name" placeholder="请输入活动名称" :maxlength='10' :suffix="form.name.length+'/10'" style="width:350px" />
        </a-col>
        <a-col :span="4">
          <p class="s_c999">（限10个字内）</p>
        </a-col>
      </a-row>
    </a-form-item>
    <a-form-item ref="activityTime" label="有效期" name="activityTime">
      <a-range-picker :show-time="{
              hideDisabledOptions: true
            }" :disabled-date="disabledDate" v-model:value="time" format="YYYY-MM-DD" valueFormat='YYYY-MM-DD' />
    </a-form-item>
    <a-form-item ref="preferential_content" label="核销内容" name="preferential_content">
      <a-textarea v-model:value="form.preferential_content" showCount :maxlength="200" style="width:350px" />
    </a-form-item>
    <a-form-item ref="image_url" label="核销图片" name="image_url">
         <material :groupType='1' :imageList="form.img" :max="5" v-on:handlechoose="(data)=>{form.img=data}" v-on:handledel="(data)=>{form.img = data;}" />
    </a-form-item>
    <a-form-item ref="is_open" label="活动状态" name='is_open'>
      <a-radio-group v-model:value="form.is_open">
        <a-radio :value="1">启用</a-radio>
        <a-radio :value="0">禁用</a-radio>
      </a-radio-group>
    </a-form-item>
    <a-form-item required ref="" label="参与区域" name='' style='margin-bottom: 10px;'>
      <a-radio-group v-model:value="form.appoint_dealer_type" :disabled="$route.query.type != 'add'">
        <a-radio :value="0">全部经销商</a-radio>
        <a-radio :value="1">适用以下经销商</a-radio>
        <a-radio :value="2">排除以下经销商</a-radio>
      </a-radio-group>
    </a-form-item>
    <a-form-item name='dealer_list' :wrapper-col="{offset:3,span:18}" v-if="form.appoint_dealer_type!=0">
      <a-button @click="showDealer=true" v-if="$route.query.type == 'add'">选择经销商</a-button>
      <a-table class='m-t-15 m-b-15' :pagination='false' bordered rowKey='dealer_id' :columns='dealerColumns' :data-source='form.appoint_dealer_data'>
        <template v-slot:action="{ index }">
          <a-button type="link" @click='delDealer(index)' :disabled="$route.query.type != 'add'">删除</a-button>
        </template>
      </a-table>
    </a-form-item>
    <a-form-item :wrapper-col="{ span: 14, offset: 3 }" v-if='$route.query.type !=="look"'>
      <a-button type="primary" @click="onSubmit">下一步</a-button>
    </a-form-item>
  </a-form>
  <a-modal title="选择经销商" v-model:visible="showDealer" centered :width='1300' :footer="null" destroyOnClose>
    <selectDealer v-on:select="dealerSelect" :selectList='form.appoint_dealer_data' :checkout="true"></selectDealer>
  </a-modal>
</template>

<script>
import { ref, onMounted, reactive, toRefs, inject } from "vue";
import {
  createPickUpCoupon,
  updatePickUpCoupon,
  pickUpCouponDetailOne,
} from "@/api/assets";
import { message } from "ant-design-vue";
import { iscode } from "@/utils/app";
import store from "@/store";
// 初始化默认筛选项数值
let defForm = {
  name: "",
  start_time: "",
  end_time: "",
  is_open: 0,
  preferential_content: "",
  appoint_dealer_type: 0,
  appoint_dealer_data: [],
  img: [],
};
export default {
  props: {
    id:  Number || String,
  },
  setup(props, { emit }) {
    let signingTime = async () => {
      if (state.time.length == 0) {
        return Promise.reject("请选择活动时间");
      }
      // else if (testTime(state.time[0]) < 10 && $route.query.type == "add") {
      //   return Promise.reject("活动开始时间最少需要大于当前时间10分钟");
      // }
      //  else if (datedifference(state.time[0], state.time[1]) > 90) {
      //   return Promise.reject("活动时间不得大于90天");
      // }
      else {
        return Promise.resolve();
      }
    };
    let dealer_list = async () => {
      if (
        form.value.appoint_dealer_type !== 1 &&
        !form.value.dealer_list.length
      ) {
        return Promise.reject("请选择经销商");
      } else {
        return Promise.resolve();
      }
    };
    const showCoupon = ref(false); //关联优惠券弹窗
    const ruleForm = ref();
    const $route = inject("$route");
    const $router = inject("$router");
    const momentTime = inject("momentTime");
    const form = ref(JSON.parse(JSON.stringify(defForm)));
    const state = reactive({
      showDealer: false,
      info: store.state.user.info,
      showCoupon: false,
      dealer_list: [], // 已选的经销商
      couponList: [], // 已选择的优惠券
      labelCol: { span: 3 },
      wrapperCol: { span: 18 },
      rules: {
        name: [{ required: true, message: "请输入活动名称" }],
        activityTime: [{ required: true, validator: signingTime }],
        preferential_content: [{ required: true, message: "请输入核销内容" }],
        appoint_dealer_data: [{ required: true, validator: dealer_list }],
      },
      time: [],
    });
    const dealerColumns = [
      //经销商table头
      {
        title: "经销商编号",
        dataIndex: "dealer_sn",
        key: "dealer_sn",
      },
      {
        title: "经销商名称",
        dataIndex: "dealer_name",
        key: "dealer_name",
      },
      {
        title: "经销商级别",
        dataIndex: "level_name",
        key: "level_name",
      },
      {
        title: "联系人",
        dataIndex: "leader_name",
        key: "leader_name",
      },
      {
        title: "手机号码",
        dataIndex: "leader_phone",
        key: "leader_phone",
      },
      {
        title: "操作",
        key: "action",
        width: 120,
        slots: { customRender: "action" },
      },
    ];
    const disabledDate = (current) => {
      return current < momentTime().subtract(1, "days");
    };
    // 判断时间
    const testTime = (time) => {
      var nowTime = momentTime().format();
      var startTime = momentTime(time);
      return startTime.diff(nowTime, "minute");
    };
    const datedifference = (date1, date2) => {
      var sDate = new Date(date1);
      var eDate = new Date(date2);
      var aDay = 24 * 60 * 60 * 1000;
      var diffDay = (eDate - sDate) / aDay;
      return diffDay;
    };
    //获取详情
    const getMore = async (id) => {
      const hide = message.loading("正在加载中...", 0);
      let res = await pickUpCouponDetailOne({ id })
        .then((res) => res.data)
        .catch((error) => error);
      if (iscode(res)) {
        form.value = res.data;
        state.time = [res.data.start_time, res.data.end_time];
      } else {
        message.error(res.msg);
      }
      setTimeout(hide);
    };
    const delDealer = (e) => {
      form.value.appoint_dealer_data.splice(e, 1);
    };
    //选择经销商
    const dealerSelect = (e) => {
      state.showDealer = false;
      form.value.appoint_dealer_data = e;
    };
    //提交
    const onSubmit = () => {
      ruleForm.value
        .validate()
        .then(async () => {
          if (
            form.value.appoint_dealer_type != 0 &&
            !form.value.appoint_dealer_data.length
          ) {
            message.error("请选择经销商");
            return;
          }
          let res;
          const hide = message.loading("正在加载中...", 0);
          if (!$route.query.id&&!props.id) {
            res = await createPickUpCoupon({
              ...form.value,
              start_time: state.time[0],
              end_time: state.time[1],
            })
              .then((res) => res.data)
              .catch((error) => error);
          } else {
            res = await updatePickUpCoupon({
              id: $route.query.id,
              ...form.value,
              start_time: state.time[0],
              end_time: state.time[1],
            })
              .then((res) => res.data)
              .catch((error) => error);
          }
          setTimeout(hide);
          if (iscode(res, true)) {
            var id=res.data.id || $route.query.id
            setTimeout(() => {
              emit("oneDone",id);
            }, 1000);
          }
        })
        .catch((error) => {
          message.error("请完善表单！");
        });
    };
    onMounted(() => {
      if ($route.query.id) {
        getMore($route.query.id);
      }
      if(props.id){
        getMore(props.id);
      }
    });
    return {
      ...toRefs(state),
      form,
      ruleForm,
      onSubmit,
      datedifference,
      momentTime,
      disabledDate,
      showCoupon,
      testTime,
      dealerColumns,
      dealerSelect,
      delDealer,
    };
  },
};
</script>
<style>
</style>